module.exports = __webpack_public_path__ + "img/eagle_eye_logo.25f0bc42.jpg";